import React from 'react';
import { Checkbox, Grid, Stack, Text } from 'library/ui';
import { IBusinessLocation } from 'models';

interface ISelectPermissionsProps {
    availableLocations: IBusinessLocation[];
    selectedLocations: number[];
    onLocationSelect: (id: number) => void;
    onSelectAll: () => void;
}

export default function SelectLocations({
    availableLocations,
    selectedLocations,
    onLocationSelect,
    onSelectAll,
}: ISelectPermissionsProps) {
    return (
        <Stack gap="sm">
            <Text weight="semibold">Select Location Access*</Text>
            <Checkbox
                label="All Location"
                checked={selectedLocations.length > 0 && selectedLocations.length === availableLocations.length}
                onChange={() => onSelectAll()}
            />
            <Grid columns={2} gap="sm" collapseAt="sm">
                {availableLocations.map((x) => (
                    <Checkbox
                        key={x.id}
                        label={x.name}
                        checked={selectedLocations.includes(x.id)}
                        onChange={() => onLocationSelect(x.id)}
                    />
                ))}
            </Grid>
        </Stack>
    );
}
